import {Alert, Button, Col, Row, Space, Spin, Tooltip} from "antd";
import {QuestionCircleOutlined} from "@ant-design/icons";
import {StyledCustomersDataBox} from "../../../../../styles/customers/customers";
import {usePricingCurrencies} from "../../../../../features/currencies";
import {SessionSalesInsights} from "../../../../../features/sessions";

type TRevenueSection = {
  salesInsights?: SessionSalesInsights;
  isLoadingSalesInsights: boolean;
};

export function RevenueSection({salesInsights, isLoadingSalesInsights}: TRevenueSection) {
  const pricingCurrencies = usePricingCurrencies();

  if (isLoadingSalesInsights) {
    return (
      <div style={{marginTop: "2.4rem", textAlign: "center", padding: "4rem"}}>
        <Spin size="large" />
      </div>
    );
  }

  if (!salesInsights) {
    return (
      <div style={{marginTop: "2.4rem"}}>
        <Alert
          message="No sales data"
          description="No sales insights available for this session."
          type="info"
          showIcon
        />
      </div>
    );
  }

  const {totalBookings = 0, totalRevenue = []} = salesInsights;
  const payoutCurrency = pricingCurrencies.bankAccount?.currency;
  // Prefer the payout-currency revenue; fall back to the first entry so revenue
  // is never hidden when it was earned in a different currency.
  const chosenRevenue =
    totalRevenue.find((item) => item.currency === payoutCurrency) ?? totalRevenue[0];
  const displayCurrency = chosenRevenue?.currency ?? payoutCurrency ?? "NGN";
  const totalRevenueAmount = chosenRevenue?.totalRevenue ?? 0;

  return (
    <div style={{marginTop: "2.4rem"}}>
      <Space size={16} direction="vertical" style={{display: "flex"}}>
        <Row gutter={[59, 20]}>
          <Col span={24} md={12}>
            <StyledCustomersDataBox
              style={{
                backgroundColor: "#EAE6F3",
                color: "#272037",
                borderRadius: "5px",
                border: "1.6px solid #43375D",
                height: "auto",
              }}
            >
              <div style={{backgroundColor: "#B3A8CD"}} className="data-circle"></div>
              <p className="data-box-title">
                Total revenue
                <Tooltip
                  placement="left"
                  title="Your total revenue is calculated in your payout currency"
                >
                  <Button icon={<QuestionCircleOutlined />} size="small" type="text" />
                </Tooltip>
              </p>
              <h2 className="data-box-value">{`${displayCurrency} ${totalRevenueAmount.toLocaleString()}`}</h2>
            </StyledCustomersDataBox>
          </Col>
          <Col span={24} md={12}>
            <StyledCustomersDataBox
              style={{
                backgroundColor: "#E7EDE1",
                color: "#16350F",
                borderRadius: "5px",
                border: "1.6px solid #355D2C",
                height: "auto",
              }}
            >
              <div style={{backgroundColor: "#B6C2A8"}} className="data-circle"></div>
              <p className="data-box-title">
                Total bookings
                <Tooltip placement="left" title="Total number of session bookings">
                  <Button icon={<QuestionCircleOutlined />} size="small" type="text" />
                </Tooltip>
              </p>
              <h2 className="data-box-value">{totalBookings.toLocaleString()}</h2>
            </StyledCustomersDataBox>
          </Col>
        </Row>
      </Space>
    </div>
  );
}
